var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _rect3, _rect4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _path14, _circle2, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageUploader = function SvgImageUploader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187,
    height: 187,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    fill: "#F2F2F2",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M149.64 146.947a1.02 1.02 0 0 0-.407-1.386l-32.434-17.715a1.02 1.02 0 0 0-1.386.407l-9.566 17.515a1.02 1.02 0 0 0 .407 1.386l32.434 17.715c.495.27 1.116.088 1.386-.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "m126.176 133.827-9.691 17.744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M121.295 136.395a1.35 1.35 0 0 0-.537-1.829l-2.957-1.615a1.348 1.348 0 0 0-1.292 2.366l2.957 1.615a1.347 1.347 0 0 0 1.829-.537"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "#D9D9D9",
    rx: 3.37,
    transform: "scale(-1 1)rotate(-28.642 215.366 359.693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M64.474 143.577 65 142l.526 1.577a3 3 0 0 0 1.897 1.897L69 146l-1.577.526a3 3 0 0 0-1.897 1.897L65 150l-.526-1.577a3 3 0 0 0-1.897-1.897L61 146l1.577-.526a3 3 0 0 0 1.897-1.897"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m151.62 102.639 5.331-15.101a1.047 1.047 0 1 0-2.012-.566zM146.983 100.768l5.656-15.3a.716.716 0 1 0-1.362-.437zM135.855 96.28l6.545-14.943a.715.715 0 1 1 1.283.631z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 4,
    x: 150.935,
    y: 82.953,
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    transform: "rotate(21.97 150.935 82.953)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 140.734,
    y: 78.838,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2,
    transform: "rotate(21.97 140.734 78.838)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m156.273 84.74 8.11-13.27M150.382 81.652l3.757-14.659M153.441 83.425l6.023-14.284"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M152.289 67.28s3.203.603 6.759 2.038 6.281 3.223 6.281 3.223"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M152.289 67.28s3.203.603 6.759 2.038 6.281 3.223 6.281 3.223"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M45.7 46.503c-.268-.797-.451-1.338-.626-1.745-.17-.395-.3-.581-.42-.7a1.95 1.95 0 0 0-1.077-.534c-.167-.024-.394-.015-.812.088-.429.107-.97.288-1.767.557L26.1 49.182c-.797.269-1.338.451-1.744.626-.396.17-.582.3-.7.42-.287.294-.474.671-.534 1.077-.025.168-.016.394.088.812.106.43.288.97.556 1.768l3.556 10.564c.268.798.45 1.338.626 1.745.17.395.3.581.42.7.293.287.67.474 1.077.534.167.025.393.016.811-.088.43-.107.97-.288 1.768-.556l14.897-5.014c.798-.268 1.338-.451 1.745-.626.395-.17.581-.3.7-.42.287-.294.474-.67.534-1.077.025-.167.015-.394-.088-.812-.107-.43-.288-.97-.556-1.768z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M46.93 54.932c-.27-.797-.452-1.338-.627-1.744-.17-.396-.3-.582-.42-.7a1.95 1.95 0 0 0-1.077-.535c-.167-.024-.393-.015-.811.089-.43.106-.971.288-1.768.556l-6.061 2.04c-.954.32-1.612.543-2.109.757-.486.209-.736.377-.903.548a2.53 2.53 0 0 0-.697 1.403c-.035.237-.017.537.11 1.05.13.526.351 1.184.672 2.138l.28.835c.322.953.544 1.611.758 2.108.209.487.377.736.548.904.383.374.874.618 1.403.696.237.035.538.018 1.051-.11.525-.13 1.184-.35 2.137-.671l6.061-2.04c.797-.268 1.338-.451 1.745-.626.395-.17.581-.3.7-.42.287-.294.474-.67.534-1.077l.989.146-.99-.146c.025-.167.016-.394-.087-.812-.107-.429-.288-.97-.557-1.767zM56.061 27.128c-.32-.954-.543-1.611-.757-2.108-.209-.487-.377-.736-.548-.904a2.53 2.53 0 0 0-1.403-.696c-.237-.035-.537-.018-1.05.11-.526.13-1.184.35-2.138.671l-13.72 4.618c-.855.287-1.442.486-1.89.676-.435.185-.666.334-.828.488-.358.34-.609.777-.722 1.257-.05.218-.063.492-.003.962.062.482.187 1.09.37 1.973l3.911 18.864 24.7-8.313z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M66.52 41.484c-.373-1.11-.635-1.885-.888-2.472-.248-.577-.454-.89-.676-1.108a3.12 3.12 0 0 0-1.729-.858c-.307-.045-.681-.02-1.29.13-.621.155-1.397.415-2.507.789l-14.555 4.898c-.797.269-1.338.451-1.744.626-.396.17-.582.3-.7.42-.287.294-.475.67-.535 1.077-.024.168-.015.394.089.812.106.43.288.97.556 1.768l3.555 10.564c.269.797.452 1.338.626 1.745.17.395.3.581.42.7.294.287.671.474 1.077.534.168.025.394.015.812-.088.43-.107.97-.288 1.768-.556l14.555-4.899c1.11-.373 1.885-.635 2.472-.888.577-.248.89-.454 1.108-.676a3.12 3.12 0 0 0 .858-1.729c.045-.307.02-.681-.131-1.29-.154-.621-.414-1.397-.788-2.507zM30.012 52.438c-.272-.808-.46-1.366-.637-1.79-.173-.417-.308-.636-.441-.787a2.54 2.54 0 0 0-1.708-.847c-.2-.015-.456.01-.893.124-.445.116-1.003.303-1.81.575s-1.366.46-1.79.637c-.417.173-.636.307-.787.44a2.54 2.54 0 0 0-.847 1.708c-.015.201.01.457.124.894.116.445.303 1.002.575 1.81l3.057 9.083c.32.953.543 1.611.757 2.108.209.487.377.736.548.904.382.374.873.618 1.403.696.237.035.537.018 1.05-.11.526-.13 1.184-.35 2.138-.671l1.177-.397c.641-.215 1.065-.358 1.38-.494.306-.132.428-.223.496-.293.2-.205.331-.467.373-.75.014-.098.013-.25-.067-.573-.083-.333-.224-.757-.44-1.398z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m68.216 60.108-2.18-4.09-2.166.729zM54.366 64.339l-2.18-4.09-2.167.73zM32.833 72.016l-.736-4.576 2.166-.729z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M55.102 24.495a1.77 1.77 0 0 0-2.074-1.082l-4.8 1.189 3.298 15.772 8.564-2.883z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    d: "M48.787 46.12c-.272-.808-.46-1.366-.637-1.79-.173-.417-.308-.636-.441-.787A2.53 2.53 0 0 0 46 42.696c-.2-.016-.457.01-.893.123-.445.117-1.003.304-1.81.576-.809.271-1.366.46-1.79.636-.417.173-.636.308-.787.441a2.53 2.53 0 0 0-.847 1.708c-.016.2.01.457.123.893.117.445.304 1.003.575 1.81l3.659 10.87c.215.64.359 1.064.494 1.38.132.305.223.427.293.496.205.2.467.331.75.373.098.014.25.013.573-.067.333-.083.757-.225 1.398-.44l1.177-.397c.954-.32 1.612-.543 2.109-.756.486-.21.736-.377.904-.549.374-.382.618-.873.696-1.403.035-.237.018-.537-.11-1.05-.13-.526-.35-1.184-.672-2.138z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.25 122.745 36 116l.75 6.745a3 3 0 0 0 2.488 2.628L43 126l-3.762.627a3 3 0 0 0-2.489 2.628L36 136l-.75-6.745a3 3 0 0 0-2.488-2.628L29 126l3.762-.627a3 3 0 0 0 2.489-2.628"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 103.5,
    r: 2.5,
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M137.474 31.577 138 30l.526 1.577a3 3 0 0 0 1.897 1.897L142 34l-1.577.526a3 3 0 0 0-1.897 1.897L138 38l-.526-1.577a3 3 0 0 0-1.897-1.897L134 34l1.577-.526a3 3 0 0 0 1.897-1.897"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 93,
    r: 32,
    fill: "#BFBAFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M89.479 79.072h9.043c.62 0 1.434.426 1.816.951l2.485 3.868c.243.377.646.605 1.077.605h5.345c1.247 0 2.255 1.074 2.255 2.405v17.477c0 1.329-1.008 2.406-2.255 2.406H78.756c-1.246 0-2.256-1.075-2.256-2.406V86.901c0-1.329 1.01-2.405 2.257-2.405h5.366c.416 0 .807-.22 1.043-.584l2.496-3.889c.383-.524 1.2-.951 1.817-.951m13.047 8.776c0 .765.602 1.385 1.346 1.385s1.346-.62 1.346-1.385-.601-1.386-1.346-1.386c-.744 0-1.346.621-1.346 1.386m-16.154 6.928c0 4.591 3.616 8.313 8.077 8.313s8.077-3.722 8.077-8.313c0-4.593-3.615-8.314-8.077-8.314s-8.077 3.72-8.077 8.314m-6.058-14.78h2.245c.62 0 1.12.616 1.12 1.386v1.385h-4.487v-1.385c0-.766.5-1.386 1.122-1.386m7.853 14.78c0-3.573 2.811-6.467 6.282-6.467s6.282 2.894 6.282 6.467c0 3.571-2.812 6.466-6.282 6.466s-6.282-2.895-6.282-6.466",
    clipRule: "evenodd"
  })));
};
export default SvgImageUploader;